import React, { useEffect, useState } from 'react'
import { FORM_CALLE_DE_CALADO } from '../../../../config/forms'
import { formValueSelector, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import CamposCalleDeCalado from './CamposCalleDeCalado'

function EdicionCalleDeCalado (props) {
  const { calle, change: formChange, cerealAsignado, capacidadCalle, habilitado } = props
  const [dataInicial, setDataInicial] = useState(false)

  useEffect(() => {
    function getData () {
      console.log(calle, calle.habilitado, calle.numero)
      formChange('numero', calle.numero)
      formChange('cereal', calle.cerealAsignado)
      formChange('capacidadCalle', calle.capacidad)
      formChange('habilitado', calle.habilitado.trim() === 'Sí')
    }

    if (!dataInicial) {
      getData()
      setDataInicial(true)
    }
  }, [formChange, calle, setDataInicial, dataInicial])

  return (
    <CamposCalleDeCalado
      cerealInicial={cerealAsignado}
      capacidadInicial={capacidadCalle}
      habilitadoInicial={habilitado}
      disabled={calle.ocupado > 0}
    />
  )
}

const selector = formValueSelector(FORM_CALLE_DE_CALADO)

const mapStateToProps = (state) => ({
  capacidadCalle: selector(state, 'capacidadCalle'),
  cerealAsignado: selector(state, 'cereal'),
  habilitado: selector(state, 'habilitado')
})

const withRedux = connect(mapStateToProps, null)

const withReduxForm = reduxForm({
  form: FORM_CALLE_DE_CALADO
})

export default withRedux(withReduxForm(EdicionCalleDeCalado))
